import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Flex, Typography, Button, theme } from 'antd';
import { InfoCircleOutlined, ArrowRightOutlined } from '@ant-design/icons';

import { CustomTooltip } from '../../../components/Tooltip';
import useTrackDashboardV3Event from '../useTrackDashboardV3Event';
import { LoadErrorEmptyState, WIDGET_LOAD_ERROR_HEADLINES, type WidgetLoadError } from '~features/empty-states';

type KPICardProps = {
  title: string;
  titleTooltip: string;
  isLoading: boolean;
  link?: string;
  error?: WidgetLoadError;
};
function KPICard({ children, title, titleTooltip, isLoading, link, error }: React.PropsWithChildren<KPICardProps>) {
  const { token } = theme.useToken();
  const track = useTrackDashboardV3Event();

  const defaultLink = `/cdn-analytics${window.location.search}`;
  const actualLink = link || defaultLink;

  const onLinkClicked = () => {
    track('SeeMoreClicked', { kpi_card_name: title, location_tab: actualLink });
  };

  return (
    <Card
      styles={{ body: { paddingTop: 17 } }}
      style={{
        flexShrink: 0,
        width: 310,
        boxShadow:
          '0px 1px 2px 0px rgba(0, 0, 0, 0.03), 0px 1px 6px -1px rgba(0, 0, 0, 0.02), 0px 2px 4px 0px rgba(0, 0, 0, 0.02)',
      }}
      loading={isLoading}
    >
      <Flex justify="space-between" align="center">
        <Typography.Text strong>
          <span>{title}</span>
          <CustomTooltip placement="top" message={titleTooltip}>
            <InfoCircleOutlined style={{ color: token.colorIcon, marginLeft: 4 }} />
          </CustomTooltip>
        </Typography.Text>
        <Link to={actualLink} onClick={onLinkClicked}>
          <Button size="small" icon={<ArrowRightOutlined style={{ width: 14, height: 14 }} />} type="text" />
        </Link>
      </Flex>
      {error ? (
        <LoadErrorEmptyState
          screen="dashboard"
          headline={WIDGET_LOAD_ERROR_HEADLINES.metric}
          onRetry={error.onRetry}
          compact
        />
      ) : (
        children
      )}
    </Card>
  );
}

export default KPICard;
